import React from 'react'

import Box from 'components_new/atoms/Box'
import Skeleton from 'components_new/atoms/Skeleton'

import ThumbnailList from 'components_new/molecules/ThumbnailList'

const Loading = () => {
  return (
    <Box>
      <Skeleton variant="rounded" width={'100%'} height={350} />
      <ThumbnailList
        itemSize={{
          xs: 12,
          md: 12,
          lg: 12,
          xl: 12
        }}
        spacing={1}
      >
        {[1, 2, 3, 4, 5].map((item) => (
          <Skeleton key={item} variant="rounded" width={'100%'} height={48} />
        ))}
      </ThumbnailList>
    </Box>
  )
}

Loading.displayName = 'Loading'

export default Loading
